<template>
  <div class="home-ticker">
    <transition>
      <div
        :key="activeItem"
        class="home-ticker__item"
        v-text="activeItem"
      />
    </transition>
  </div>
</template>

<script>
  import dynamicComponent from '@/mixins/dynamic-component';

  export default {
    name: 'TextTicker',
    mixins: [dynamicComponent],
    props: {
      items: {
        type: Array,
        required: true,
      },
      interval: {
        type: Number,
        default: 3000,
      },
    },
    data() {
      return {
        handle: undefined,
        activeItem: undefined,
      };
    },
    created() {
      this.setActiveItem();
      setInterval(this.setActiveItem, this.interval);
    },
    methods: {
      setActiveItem() {
        const items = this.items.filter(item => item !== this.activeItem);
        const { floor, random } = Math;

        this.activeItem = items[floor(random() * items.length)];
      },
    },
  };
</script>

<style
    lang="scss"
    scoped
>

    .home-ticker {
      @include container;
      position: relative;
      z-index: 2;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }

    .home-ticker__item {
        @include column;
        position: absolute;
        overflow: hidden;
        width: percentage(10 / 12);
        font-size: 2.8rem;
        line-height: 1.3;
        font-family: font-family(sans-serif);
        font-weight: font-weight(extra-bold);
        text-align: center;
        text-transform: uppercase;
        color: color(red);

        @include breakpoint(phablet) {
          font-size: 7.3rem;
          line-height: 1;
        }
    }

    .v-enter-active,
    .v-leave-active {
        opacity: 0;
        transition-property: transform, opacity;
        transition-duration: 500ms;
    }

    .v-leave-active {
        position: absolute;
    }

    .v-enter {
        transform: translateY(100%);
    }

    .v-enter-to {
        opacity: 1;
    }

    .v-leave {
        opacity: 1;
    }

    .v-leave-to {
        transform: translateY(-100%);
    }
</style>
